import { hover } from 'pobble-components/dist/jss-mixins'

export default ({ COLORS }) => ({
  button: {
    textDecoration: 'none',
    textAlign: 'left',
    fontWeight: 'bold',
    padding: '.5em 1em',
    cursor: 'pointer',
    border: `1px solid ${COLORS.BLUE.NORMAL}`,
    color: COLORS.BLUE.NORMAL,
    borderRadius: '4px',
    background: 'none',
    fontSize: '16px',
    lineHeight: '1.2',
    display: 'inline-flex',
    alignItems: 'center',
    transition: 'all .3s',
    ...hover({
      color: '#FFF',
      backgroundColor: COLORS.BLUE.EXTRA_FADED
    })
  },
  iconHolder: {
    width: '.7em',
    height: '.7em',
    margin: '0 .4em 0 -.2em',
    flexShrink: '0',
    '& svg': {
      width: '100%',
      height: '100%',
      display: 'block'
    }
  }
})
